import React, { useEffect, useRef, useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const RyadVideo = () => {
  const { t } = useLanguage();
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const handleWhatsAppVideo = () => {
    const message = encodeURIComponent("Bonjour, je souhaite réserver un appartement à la Résidence RYAD en VEFA.");
    window.open(`https://wa.me/221787172828?text=${message}`, '_blank');
  };

  const handleCatalogDownload = () => {
    window.open('https://customer-assets.emergentagent.com/job_luxury-ryad/artifacts/67gzfaj3_CATALOGUE%20RYAD%20residence.pdf', '_blank');
  };

  return (
    <section id="video" ref={sectionRef} className="py-24 bg-gradient-to-br from-slate-900 via-gray-900 to-slate-900 relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-80 h-80 bg-blue-500/5 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-amber-500/3 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Section Header */}
        <div className={`text-center mb-16 transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
          <span className="inline-block px-4 py-2 bg-amber-500/20 text-amber-400 rounded-full text-sm font-semibold mb-6 tracking-wide uppercase border border-amber-500/30">
            Visite Virtuelle
          </span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            {t.video.title}
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed">
            {t.video.subtitle}
          </p>
        </div>

        <div className="max-w-7xl mx-auto">
          {/* Main Video Section - Premium Design */}
          <div className={`mb-16 transform transition-all duration-1000 delay-200 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
            <div className="relative group">
              {/* Video Container */}
              <div className="relative rounded-3xl overflow-hidden shadow-2xl shadow-black/50 border border-white/10">
                <video 
                  className="w-full h-96 md:h-[500px] lg:h-[600px] object-cover"
                  controls
                  poster="https://customer-assets.emergentagent.com/job_luxury-ryad/artifacts/8m0mf6b4_SALON%201.jpg"
                  preload="metadata"
                  onPlay={() => setIsPlaying(true)}
                  onPause={() => setIsPlaying(false)}
                >
                  <source src="https://customer-assets.emergentagent.com/job_luxury-ryad/artifacts/f7w20qow_Pr%C3%A9sentation%20de%20la%20r%C3%A9sidence%20RYAD%20%28F4%29.MOV" type="video/mp4" />
                  Votre navigateur ne supporte pas la lecture vidéo.
                </video>
                
                {/* Video Badge */}
                <div className={`absolute top-6 left-6 transition-opacity duration-300 ${isPlaying ? 'opacity-0' : 'opacity-100'}`}>
                  <div className="flex items-center gap-3 bg-black/60 backdrop-blur-md px-5 py-3 rounded-full border border-white/20">
                    <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse"></div>
                    <span className="text-white font-semibold">Appartement F4</span>
                  </div>
                </div>

                {/* Duration badge */}
                <div className={`absolute bottom-6 right-6 transition-opacity duration-300 ${isPlaying ? 'opacity-0' : 'opacity-100'}`}>
                  <div className="bg-black/60 backdrop-blur-md px-4 py-2 rounded-full border border-white/20">
                    <span className="text-white text-sm">🎬 Visite complète</span>
                  </div>
                </div>
              </div>

              {/* Glow effect */}
              <div className="absolute -inset-1 bg-gradient-to-r from-amber-500/20 via-transparent to-amber-500/20 rounded-3xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RyadVideo;
